import { Box } from "@chakra-ui/react";
import MilestoneOverview from "../services/CreateMilestone";

export default function MilestoneContainer() {
    return (
        <Box width="90%" mx="auto">
            <MilestoneOverview />
        </Box>
    );
}
